import { type ComponentProps, useEffect } from "react";

import { Link, useFetcher } from "@remix-run/react";
import { ShoppingCartIcon } from "lucide-react";

import { cn } from "~/lib/utils";

import { CountDownTimer } from "./shared";

export function CartLink() {
    const fetcher = useFetcher();

    useEffect(() => {
        fetcher.load("/api/cart");
    }, []);

    let count = 0;
    let space = null;

    if (fetcher.data && fetcher.data.cart) {
        const { cart } = fetcher.data;
        count = cart.packages.length + cart.spaces.length;
        if (cart?.spaces[0]) {
            space = cart?.spaces[0] && cart?.spaces[0].space;
        }
    }

    return (
        <section className="flex items-center">
            <Link to="/cart" className="relative flex items-center gap-8 pl-4" aria-label="Cart">
                <ShoppingCartIcon width="1.3em" height="1.3em" className="mr-4" />
                <Dot className={count === 0 ? "opacity-0" : "opacity-100"} count={count} />
            </Link>
            {space && <CountDownTimer space={space} isToolBar={true} />}
        </section>

    );
}

function Dot({ className, count }: ComponentProps<"div">) {
    const dotStyles = count.toString().length > 1 ? "w-[19px] h-[19px]" : "w-4 h-4"

    return (
        <div
            className={cn(
                "absolute bg-destructive top-0 left-5 translate-x-2/4 -translate-y-2/4 transition-opacity duration-300 rounded-full flex items-center justify-center text-xs text-white font-bold",
                className,
                dotStyles
            )}
        >
            {count}
        </div>
    );
}
